// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vfeWg","footer":"styles_footer__3423B"};